"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeniedIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var themes_1 = require("../../themes");
var withSVGIcon_1 = require("./withSVGIcon");
var Icon = function (_a) {
    var _b = _a.strokeWidth, strokeWidth = _b === void 0 ? 1 : _b;
    return (jsx_runtime_1.jsxs(jsx_runtime_1.Fragment, { children: [jsx_runtime_1.jsx("circle", { cx: "16", cy: "16", r: "12.25", fill: themes_1.THEME.colors.danger.Red100, stroke: "black", strokeWidth: strokeWidth }, void 0),
            jsx_runtime_1.jsx("rect", { x: "8.75", y: "13.75", width: "14.5", height: "4.5", fill: "white", stroke: "black", strokeWidth: strokeWidth }, void 0)] }, void 0));
};
exports.DeniedIcon = withSVGIcon_1.withSVGIcon(Icon, { viewBox: '0 0 32 32' });
//# sourceMappingURL=DeniedIcon.js.map